export const es = {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    update: "Actualizar",
    loading: "Cargando",
    error: "Error",
    saved: "Guardado",
    yes: "Sí",
    no: "No",
    all: "Todo",
    apply: "Aplicar",
    signOut: "Cerrar sesión",
    confirm: "Confirmar",
    optionalNotes: "Notas opcionales",
    confirmDelete: "Confirmar eliminación",
    current: "Actual",
    ok: "OK",
    warning: "Advertencia",
    success: "Éxito",
    back: "Atrás",
    copied: "Copiado",
    refresh: "Actualizar",
    add: "Añadir",
    change: "Cambiar",
    countryCode: "Código de país",
    none: "Ninguno",
  },

  auth: {
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    register: "Registrarse",
    email: "Email",
    phone: "Teléfono",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    firstName: "Nombre",
    lastName: "Apellido",
    accountName: "Nombre de la cuenta",
    loginFailed: "Error al iniciar sesión.",
    signInSubtitle: "Gestiona tus apartamentos, reservas y huéspedes.",
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordSubtitle:
      "Introduce tu email y te enviaremos instrucciones para restablecer tu contraseña.",
    sendResetLink: "Enviar enlace de restablecimiento",
    backToLogin: "Volver al inicio de sesión",
    or: "o",
    loginWithGoogle: "Continuar con Google",
    loginWithFacebook: "Continuar con Facebook",
    noAccount: "¿No tienes una cuenta?",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    registerSubtitle:
      "Crea tu cuenta de RentPilot y empieza a gestionar tus alojamientos.",
    verifyEmailBanner:
      "Verifica tu dirección de correo electrónico antes de usar todas las funciones de RentPilot.",
    resendVerificationEmail: "Reenviar correo",
    iVerified: "Ya verifiqué",
    resetPassword: "Restablecer contraseña",
    resetPasswordSubtitle:
      "Introduce una nueva contraseña para tu cuenta de RentPilot.",
    newPassword: "Nueva contraseña",
    invalidResetLink:
      "El enlace para restablecer la contraseña no es válido o está incompleto.",
  },

  tabs: {
    calendar: "Calendario",
    properties: "Propiedades",
    statistics: "Estadísticas",
    profile: "Perfil",
    team: "Equipo",
    cleaners: "Equipo",
    support: "Soporte",
    cleaningTasks: "Tareas",
    invoices: "Facturas",
    menu: "Menú",
  },

  cleaners: {
    title: "Equipo",
    add: "Añadir",
    cleaners: "Miembros del equipo",
    newCleaner: "Nuevo miembro del equipo",
    createCleaner: "Crear miembro del equipo",
    noCleaners: "Aún no hay miembros del equipo.",
    schedule: "Horario",
    noTasks: "No hay tareas de limpieza.",
    assignCleaner: "Asignar miembro del equipo",
    cleanedHistory: "Historial de limpieza",
    noCleanedHistory: "Aún no hay unidades limpiadas.",
    failedCreateCleaner: "No se pudo crear el miembro del equipo.",
    deleteQuestion: "¿Eliminar {{name}}?",
    description:
      "Gestione los miembros del equipo y su acceso a la aplicación.",
    teamAccess: "Acceso del equipo",
    members: "miembros",
    addMemberDescription:
      "Añada un administrador, un observador o una limpiadora a su cuenta.",
    roleOverview: "Resumen de roles",
    managerDescription:
      "Puede gestionar reservas, propiedades, huéspedes, tareas y miembros del equipo.",
    viewerDescription: "Puede ver el calendario sin gestionar datos.",
    cleanerDescription: "Solo puede ver las tareas de limpieza asignadas.",
  },

  cleaning: {
    myTasks: "Mis tareas",
    today: "Hoy",
    upcoming: "Próximas",
    done: "Completadas",
    noTasksToday: "No hay tareas para hoy.",
    noUpcomingTasks: "No hay tareas próximas.",
    noDoneTasks: "No hay tareas completadas.",
    scheduled: "Programado",
    cleanedAt: "Limpiado a las",
    assignedTo: "Asignado a",
    unassigned: "Sin asignar",
    start: "Empezar",
    markCleaned: "Marcar como limpio",
    futureTaskCannotBeCompleted:
      "Esta tarea puede completarse en el día programado.",
    status: {
      pending: "Pendiente",
      in_progress: "En progreso",
      done: "Completado",
      cancelled: "Cancelado",
    },
    description:
      "Ver las tareas de hoy, las limpiezas próximas y el historial de limpiezas completadas.",
  },

  calendar: {
    unit: "Unidad",
    noUnits: "No hay unidades",
    filters: "Filtros",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    thisWeek: "Esta semana",
    twoWeeks: "Dos semanas",
    threeWeeks: "Tres semanas",
    thisMonth: "Este mes",
    occupied: "Ocupado",
    unavailable: "No disponible",
    rangeOverlaps:
      "El rango de fechas seleccionado se solapa con una reserva existente.",
    occupiedCellMessage:
      "Esta unidad ya tiene una reserva en la fecha seleccionada.",
    selectCheckIn: "Seleccionar check-in",
    selectCheckOut: "Seleccionar check-out",
    clear: "Limpiar",
    multi: "Multi",
    single: "Simple",
    next7Days: "Próximos 7 días",
    next14Days: "Próximos 14 días",
    selectedStart: "Inicio seleccionado",
    tapCheckoutDate: "Toca la fecha de check-out para crear una reserva",
    subtitle: "Resumen de unidades, reservas, pagos y limpiezas.",
    available: "Disponible",
    addObjects: "Añadir objetos",
    addObjectsDescription:
      "Crea tu primera propiedad y unidad para empezar a gestionar reservas.",
    month: "Mes",
    next: "Siguiente",
    allUnits: "Todos los apartamentos",
    checkInAfter: "Entrada después de las 14:00",
    checkOutBefore: "Salida hasta las 10:00",
    cleaning: "Limpieza",
    private: "Privado",
    closed: "Cerrado",
    today: "Hoy",
    fullYear: "Año completo",
    availableDates: "Fechas disponibles",
    availableDatesByUnit: "Fechas disponibles por apartamento",
    shown: "mostrados",
    terms: "fechas",
    noFreePeriods: "No hay fechas disponibles",
  },

  booking: {
    newBooking: "Nueva reserva",
    bookingDetails: "Detalles de la reserva",
    guestFirstName: "Nombre del huésped",
    guestLastName: "Apellido del huésped",
    guest: "Huésped",
    phone: "Teléfono",
    email: "Email",
    unit: "Unidad",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "Noches",
    pricePerNight: "Precio por noche",
    total: "Total",
    status: "Estado",
    payment: "Pago",
    paymentStatus: "Estado del pago",
    unpaid: "No pagado",
    deposit: "Depósito",
    paid: "Pagado",
    reserved: "Reservado",
    checkedIn: "Registrado",
    checkedOut: "Salida registrada",
    cancelled: "Cancelado",
    notes: "Notas",
    createBooking: "Crear reserva",
    failedCreate: "No se pudo crear la reserva.",
    guestFirstNamePlaceholder: "Juan",
    guestLastNamePlaceholder: "Pérez",
    phonePlaceholder: "+387...",
    emailPlaceholder: "juan@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Llegada alrededor de las 18:00",
    currency: "Moneda",
    dateRange: "Fechas de estancia",
    selectDates: "Seleccionar fechas",
    selectCheckIn: "Seleccionar fecha de check-in",
    selectedDateOccupied: "Esta fecha ya está ocupada.",
    selectedRangeOverlaps:
      "Las fechas seleccionadas se solapan con una reserva existente.",
    numberOfGuests: "Huéspedes",
    checkoutAfterCheckin: "El check-out debe ser después del check-in.",
    contactGuest: "Contactar al huésped",
    invoice: "Factura",
    whatsapp: "WhatsApp",
    missingEmail: "Este huésped no tiene dirección de correo electrónico.",
    missingPhone: "Este huésped no tiene número de teléfono.",
    noContactInfo:
      "Este huésped no tiene correo electrónico ni número de teléfono.",
    confirmSendInvoice: "¿Enviar factura a este huésped?",
    invoiceSent: "Factura enviada.",
    failedSendInvoice: "No se pudo enviar la factura.",
    booking: "Reserva",
    editBooking: "Editar reserva",
    saveBooking: "Guardar reserva",
    sendInvoice: "Enviar factura",
    cancelBooking: "Cancelar reserva",
    cancelBookingQuestion: "¿Seguro que quieres cancelar esta reserva?",
    bookingCreated: "Reserva creada.",
    bookingUpdated: "Reserva actualizada.",
    bookingCancelled: "Reserva cancelada.",
    failedUpdate: "No se pudo actualizar la reserva.",
    failedCancel: "No se pudo cancelar la reserva.",
    unitMissing: "Falta la unidad.",
    emailUnavailable: "El correo no está disponible.",
    emailSubject: "Información de la reserva",
    emailBody: "Hola, aquí están los detalles de tu reserva.",
    whatsappMessage: "Hola, aquí están los detalles de tu reserva.",
    missingGuestEmail: "Falta el correo del huésped.",
    confirmSendInvoiceMessage:
      "La factura se enviará al correo electrónico del huésped.",
    checked_in: "Check-in realizado",
    checked_out: "Check-out realizado",
  },

  bookingMessages: {
    title: "Mensaje de WhatsApp",
    templateOne:
      "Hola {{guest}}, tu reserva para {{unit}} está confirmada del {{checkIn}} al {{checkOut}}.",
    templateTwo:
      "Hola {{guest}}, gracias por tu reserva. El check-in es el {{checkIn}} y el check-out es el {{checkOut}}.",
    templateThree:
      "Hola {{guest}}, esperamos tu estancia en {{unit}}. Tus fechas son {{checkIn}} - {{checkOut}}.",
    templateButton: "Plantilla {{number}}",
    customPlaceholder: "Escribe tu mensaje...",
    openWhatsApp: "Abrir WhatsApp",
    customMessage: "Mensaje personalizado",
    invalidPhone: "Número de teléfono no válido.",
    missingPhone: "Falta el número de teléfono.",
    whatsappUnavailable: "WhatsApp no está disponible.",
  },

  properties: {
    title: "Propiedades",
    newProperty: "Nueva propiedad",
    createProperty: "Crear propiedad",
    propertyName: "Nombre de la propiedad",
    address: "Dirección",
    city: "Ciudad",
    notes: "Notas",
    noUnits: "Aún no hay unidades",
    units: "unidades",
    newUnit: "Nueva unidad",
    createUnit: "Crear unidad",
    unitName: "Nombre de la unidad",
    type: "Tipo",
    capacity: "Capacidad",
    defaultPricePerNight: "Precio por noche predeterminado",
    noDefaultPrice: "Sin precio predeterminado",
    guests: "huéspedes",
    disable: "Desactivar",
    enable: "Activar",
    deleteProperty: "Eliminar propiedad",
    deletePropertyQuestion:
      "¿Eliminar {{name}}? Esto solo funciona si no tiene historial de reservas.",
    deleteUnit: "Eliminar unidad",
    deleteUnitQuestion:
      "¿Eliminar esta unidad? Si tiene historial de reservas, puedes desactivarla en su lugar.",
    failedCreateProperty: "No se pudo crear la propiedad.",
    failedCreateUnit: "No se pudo crear la unidad.",
    apartment: "Apartamento",
    room: "Habitación",
    studio: "Estudio",
    house: "Casa",
    other: "Otro",
    newPropertyPlaceholder: "Sarajevo Apartments",
    addressPlaceholder: "Calle 1",
    cityPlaceholder: "Sarajevo",
    notesPlaceholder: "Notas opcionales",
    unitNamePlaceholder: "Apartamento A",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / noche",
    deletePropertySuccess: "Propiedad eliminada.",
    deleteUnitSuccess: "Unidad eliminada.",
    addUnit: "Añadir unidad",
    activeUnits: "unidades activas",
    inactiveUnits: "unidades inactivas",
    calendarSync: "Sincronización de calendario",
    calendarSyncHelp:
      "Pega aquí los enlaces de exportación iCal de Airbnb y Booking.com. RentPilot importará esos calendarios y bloqueará las fechas correspondientes.",
    airbnbIcalLink: "Enlace iCal de Airbnb",
    bookingIcalLink: "Enlace iCal de Booking.com",
    rentPilotExportLink: "Enlace de exportación RentPilot",
    rentPilotExportCalendar: "Calendario de exportación RentPilot",
    rentPilotExportHelp:
      "Copia este enlace en Airbnb y Booking.com para que puedan bloquear fechas desde RentPilot.",
    rentPilotExportHelpLong:
      "Pega este enlace en la configuración de calendario externo de Airbnb o Booking.com.",
    airbnbConnected: "Airbnb conectado",
    airbnbNotConnected: "Airbnb no conectado",
    bookingConnected: "Booking.com conectado",
    bookingNotConnected: "Booking.com no conectado",
    noExternalCalendarsConnected: "No hay calendarios externos conectados.",
    copyShareExportLink: "Copiar enlace de exportación",
    exportLinkMissing:
      "Falta el enlace de exportación. El backend no devolvió calendar_export_url para esta unidad.",
    exportLinkCopied: "Enlace de exportación copiado.",
    editUnit: "Editar unidad",
    saveUnit: "Guardar unidad",
    noUnitsDescription:
      "Añade habitaciones/apartamentos para que las reservas y las tareas de limpieza puedan asignarse a esta propiedad.",
    activateUnit: "Activar unidad",
    deactivateUnit: "Desactivar unidad",
    failedDeleteProperty: "No se pudo eliminar la propiedad.",
    failedDeleteUnit: "No se pudo eliminar la unidad.",
    failedUpdateUnit: "No se pudo actualizar la unidad.",
  },

  statistics: {
    title: "Estadísticas",
    revenue: "Ingresos",
    bookings: "Reservas",
    nights: "Noches",
    averageBooking: "Reserva promedio",
    breakdown: "Desglose",
    noStatistics: "No hay estadísticas para los filtros seleccionados.",
    groupBy: "Agrupar por",
    unit: "Unidad",
    property: "Propiedad",
    month: "Mes",
    payment: "Pago",
    sevenDays: "7 días",
    fourteenDays: "14 días",
    thirtyDays: "30 días",
    thisMonth: "Este mes",
    allProperties: "Todas las propiedades",
    allUnits: "Todas las unidades",
    byUnit: "Por unidad",
    byProperty: "Por propiedad",
    byMonth: "Por mes",
    netProfit: "Beneficio neto",
    occupancy: "Ocupación",
    profitMargin: "Margen de beneficio",
    expenseRatio: "Ratio de gastos",
    revenueByUnit: "Ingresos por unidad",
    revenueByApartment: "Ingresos por apartamento",
    noRevenueForPeriod: "No hay ingresos para el período seleccionado.",
    noExpensesForPeriod: "No hay gastos para el período seleccionado.",
    manualVsRecurringExpenses: "Gastos puntuales vs recurrentes",
    cashflow: "Flujo de caja",
    latestNetProfit: "Último beneficio neto: {{amount}}",
    performanceBreakdown: "Desglose de rendimiento",
    breakdownMeta: "{{bookings}} reservas · {{nights}} noches",
    margin: "Margen",
    revenueExpensesHint: "{{revenue}} ingresos · {{expenses}} gastos",
    expenses: "Gastos",
    expensesByCategory: "Gastos por categoría",
    filters: "Filtros",
  },

  expenses: {
    expenses: "Gastos",
    newExpense: "Nuevo gasto",
    editExpense: "Editar gasto",
    newRecurringExpense: "Nuevo gasto recurrente",
    editRecurringExpense: "Editar gasto recurrente",
    manualExpenses: "Gastos puntuales",
    recurringExpenses: "Gastos recurrentes",
    totalExpenses: "Gastos totales",
    noExpenses: "Aún no hay gastos.",
    noRecurringExpenses: "Aún no hay gastos recurrentes.",
    name: "Nombre",
    category: "Categoría",
    categoryPlaceholder: "Limpieza, servicios, mantenimiento...",
    amount: "Importe",
    date: "Fecha",
    frequency: "Frecuencia",
    monthly: "Mensual",
    yearly: "Anual",
    interval: "Intervalo",
    dayOfMonth: "Día del mes",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    active: "Activo",
    inactive: "Inactivo",
    noProperty: "Sin propiedad",
    noUnit: "Sin unidad",
    uncategorized: "Sin categoría",
    expensesByCategory: "Gastos por categoría",
    expensesByType: "Gastos por tipo",
    expensesByUnit: "Gastos por unidad",
    addExpense: "Añadir gasto",
    oneTimeExpense: "Gasto puntual",
    oneTimeExpenseDescription:
      "Úsalo para un coste único, como una reparación, toallas o una compra puntual.",
    recurringExpense: "Gasto recurrente",
    recurringExpenseDescription:
      "Úsalo para costes repetidos, como internet, suscripciones o suministros mensuales.",
  },

  profile: {
    title: "Perfil",
    firstName: "Nombre",
    lastName: "Apellido",
    phone: "Teléfono",
    saveProfile: "Guardar perfil",
    profileUpdated: "Perfil actualizado.",
    updateEmail: "Actualizar email",
    currentPassword: "Contraseña actual",
    emailUpdated: "Email actualizado.",
    password: "Contraseña",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    updatePassword: "Actualizar contraseña",
    passwordUpdated: "Contraseña actualizada.",
    passwordsDoNotMatch: "La nueva contraseña y la confirmación no coinciden.",
    language: "Idioma",
    signOutQuestion: "¿Seguro que quieres cerrar sesión?",
    failedProfileUpdate: "No se pudo actualizar el perfil.",
    failedEmailUpdate: "No se pudo actualizar el email.",
    failedPasswordUpdate: "No se pudo actualizar la contraseña.",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Nombre",
    lastNamePlaceholder: "Apellido",
    currentPasswordPlaceholder: "Contraseña actual",
    newPasswordPlaceholder: "Nueva contraseña",
    confirmNewPasswordPlaceholder: "Confirmar nueva contraseña",
    signOut: "Cerrar sesión",
    currencySettings: "Moneda",
  },

  currency: {
    currency: "Moneda",
    currencyUpdated: "Moneda actualizada",
    defaultCurrency: "Moneda predeterminada",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "No se pudo actualizar la moneda.",
  },

  support: {
    title: "Soporte",
    needSupport: "¿Necesitas ayuda?",
    description:
      "Contáctanos si necesitas ayuda con tu cuenta, reservas, propiedades, equipo o suscripción.",
    callSupport: "Llamar al soporte",
    emailSupport: "Enviar email al soporte",
  },

  subscription: {
    title: "Suscripción",
    subtitle: "Elige el plan que se adapte a tu alojamiento.",
    currentPlan: "Plan actual",
    freeNotice: "Actualmente estás usando el plan gratuito.",
    perMonth: "/ mes",
    choosePlan: "Elegir plan",
    manageBilling: "Gestionar facturación",
    upgradeRequired: "Actualización requerida",
    upgradeRequiredMessage:
      "Se ha alcanzado el límite de tu plan actual. Actualiza tu suscripción.",
    accessWarningTitle: "El acceso a RentPilot vence pronto",

    accessWarningMessage:
      "Su acceso a RentPilot vence el {{date}}. Elija o renueve un plan antes de esa fecha para seguir creando y modificando datos.",

    customAccessWarningMessage:
      "Su plan personalizado de RentPilot vence el {{date}}. Póngase en contacto con el soporte de RentPilot y acuerde el pago antes de esa fecha para seguir utilizando la aplicación.",

    accessExpiredTitle: "El acceso a RentPilot está restringido",

    accessExpiredMessage:
      "Su suscripción ha vencido o no se ha pagado. Puede seguir consultando los datos existentes, pero la creación y modificación de datos están deshabilitadas hasta que se complete el pago.",

    customAccessExpiredMessage:
      "Su plan personalizado de RentPilot ha vencido o no se ha pagado. Puede seguir consultando los datos existentes, pero la creación y modificación de datos están deshabilitadas. Póngase en contacto con el soporte de RentPilot para acordar el pago y restablecer el acceso.",

    contactAccountOwnerMessage:
      "Póngase en contacto con el propietario de la cuenta para acordar el pago y restablecer el acceso completo.",

    viewPlansCta: "Ver planes",

    contactSupportCta: "Contactar con soporte",

    noticeCloseCta: "Entendido",
    billingPeriod: "periodo de facturación",
    trialExpiresSoonBanner:
      "Tu prueba vence en {{hours}} horas. Para seguir usando RentPilot, elige un plan en la aplicación web.",
    trialExpiresSoonCta: "Elegir plan",
    billingPeriodDescription:
      "Elige cuántos meses quieres pagar por adelantado.",
    planColumn: "Plan",
    limitColumn: "Límite",
    priceColumn: "Precio",
    discountColumn: "Descuento",
    featuresColumn: "Incluido",
    actionColumn: "Acción",
    recommended: "Recomendado",
    discountBadge: "{{discount}}% de descuento",
  },

  menu: {
    pricing: "Precios",
    pricingDescription: "Consulta tu plan actual y opciones de facturación.",
    currentPlan: "Plan actual",
    pricingComingSoon: "La gestión completa de precios se conectará aquí.",
    myAccount: "Mi cuenta",
    myAccountDescription: "Perfil, email y contraseña.",
    support: "Soporte",
    supportDescription: "Contactar soporte o ver información de ayuda.",
    settings: "Configuración",
    settingsDescription: "Apariencia de la app, idioma y moneda",
    privacy: "Privacidad e información de la empresa",
    privacyDescription:
      "Información de la empresa, atención al cliente y protección de la privacidad.",
  },

  settings: {
    appAppearance: "Apariencia de la app",
    fontSize: "Tamaño de fuente",
    fontSmall: "Pequeño",
    fontMedium: "Mediano",
    fontLarge: "Grande",
    fontVeryLarge: "Muy grande",
    bookingColors: "Colores de reservas",
    theme: "Tema",
    themeSystem: "Sistema",
    themeLight: "Claro",
    themeDark: "Oscuro",
  },

  roles: {
    role: "Rol",
    owner: "Propietario",
    manager: "Gerente",
    cleaner: "Personal de limpieza",
    viewer: "Observador",
    teamMember: "Miembro del equipo",
  },

  invoices: {
    title: "Facturas enviadas",
    description: "Ver facturas enviadas e historial de correos.",
    emptyTitle: "Todavía no hay facturas",
    empty: "Todavía no se ha enviado ninguna factura.",
    failedLoad: "No se pudieron cargar las facturas.",
    sentAt: "Enviado el",
    status: {
      pending: "Pendiente",
      sent: "Enviado",
      failed: "Fallido",
    },
  },
  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  merchant: {
    title: "Información del comerciante",
    description:
      "Información sobre la entidad jurídica que proporciona y cobra el servicio RentPilot.",
    legalName: "Nombre completo de la entidad jurídica",
    address: "Dirección",
    businessActivity: "Actividad comercial",
    activityCode: "Código de actividad",
    registrationNumber: "Número de registro",
    taxNumber: "Número fiscal / JIB",
    website: "Sitio web",
    phone: "Teléfono de contacto",
    email: "Correo electrónico de contacto",

    customerServiceTitle: "Atención al cliente",
    customerServiceDescription:
      "Para obtener información sobre pedidos y pagos, reclamaciones, cancelación del servicio u otras consultas, puede ponerse en contacto con nosotros mediante los datos indicados a continuación.",

    privacyTitle: "Protección de la privacidad",
    privacyDescription:
      "RentPilot recopila únicamente los datos necesarios para prestar el servicio, gestionar las cuentas de usuario, procesar pedidos y pagos, proporcionar atención al cliente y cumplir con las obligaciones legales. Los datos personales no se venden. Solo tienen acceso a ellos las personas autorizadas y los proveedores de servicios que los necesitan para cumplir con sus obligaciones. Los datos de la tarjeta se introducen exclusivamente en la página segura del procesador de pagos y no son accesibles ni se almacenan en el sistema RentPilot.",
  },
};
